import { LoadingSpinner } from '@/components/ui/loading-spinner';

/**
 * Suspense fallback for lazy route chunks.
 *
 * One quiet centered spinner everywhere — no content-shaped skeletons.
 */
export const PageLoadingFallback = () => (
	<div className="h-screen-safe bg-background flex flex-col items-center justify-center">
		<LoadingSpinner variant="panel" />
	</div>
);
